/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ExampleImage/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import PreviewImage from 'DesignSystem/PreviewImage/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ExampleImage({
  children,
  viewPath = "/DesignSystem/PatientImageExample/Content/Content/ExampleImage",
  url
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="ExampleImage.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-3VSaV': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<PreviewImage
  viewPath={`${viewPath}/PreviewImage`}
 url={url}
 maxWidth="100%"
 maxHeight="100%"
 width="auto"
 height="auto"
 objectFit="contain"
/>
</div>
{children}
</React.Fragment>)
}